import axios from "axios";

// =====================================
// BASE URL CONFIGURATION
// =====================================
let API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) {
  throw new Error("VITE_API_BASE_URL is not defined");
}

// =====================================
// AXIOS INSTANCE
// =====================================
export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

// =====================================
// REQUEST INTERCEPTOR
// =====================================
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    const companyId = localStorage.getItem("companyId");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (companyId && !config.url.includes("/auth")) {
      config.headers["X-Company-Id"] = companyId;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

// =====================================
// RESPONSE INTERCEPTOR
// =====================================
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.replace("/login");
    }
    return Promise.reject(error);
  },
);

// =====================================
// RESPONSE HANDLER (FIXED)
// =====================================
export const handleResponse = (res) => {
  // ✅ Backend returns direct object { token, user }
  return res?.data || res;
};
